import httpClient from './httpClient';
import generateQuery from './generateQuery';

const apiUrl = process.env.REACT_APP_API;

class DataService {
  getList = (resource) =>
    httpClient(`${apiUrl}/${resource}`)
      .then(({ json }) => ({ data: json }))
      .catch(({ message }) => ({
        error: message,
      }));

  getOne = (resource, id) =>
    httpClient(`${apiUrl}/${resource}/${id}`)
      .then(({ json }) => ({ data: json }))
      .catch(({ message }) => ({
        error: message,
      }));

  getOnly = (resource, params) =>
    httpClient(`${apiUrl}/${resource}${generateQuery(params)}`)
      .then(({ json }) => ({ data: json }))
      .catch(({ message, status }) => ({
        error: message,
        status,
      }));

  updateList = (resource, params) =>
    httpClient(`${apiUrl}/${resource}`, {
      method: 'PUT',
      body: JSON.stringify(params),
    })
      .then(({ json }) => ({ data: json }))
      .catch(({ message }) => ({
        error: message,
      }));

  updateOnly = (resource, params) =>
    httpClient(`${apiUrl}/${resource}`, {
      method: 'PUT',
      body: JSON.stringify(params),
    })
      .then(({ json }) => ({ data: json }))
      .catch(({ message }) => ({
        error: message,
      }));

  createOne = (resource, params) =>
    httpClient(`${apiUrl}/${resource}`, {
      method: 'POST',
      body: JSON.stringify(params),
    })
      .then(({ json }) => ({ data: json }))
      .catch(({ message }) => ({
        error: message,
      }));

  uploadFile = (resource, data) =>
    httpClient(
      `${apiUrl}/${resource}`,
      {
        method: 'PUT',
        body: data,
      },
      true,
    )
      .then(({ json }) => ({ data: json }))
      .catch(({ message }) => ({
        error: message,
      }));

  createList = (resource, params) =>
    httpClient(`${apiUrl}/${resource}`, {
      method: 'POST',
      body: JSON.stringify(params),
    })
      .then(({ json }) => ({
        data: json,
      }))
      .catch(({ message }) => ({
        error: message,
      }));

  deleteObject = (resource, params) =>
    httpClient(`${apiUrl}/${resource}`, {
      method: 'DELETE',
      body: JSON.stringify(params),
    })
      .then(({ json }) => ({ data: json }))
      .catch(({ message }) => ({
        error: message,
      }));

  deleteOne = (resource, params) =>
    httpClient(`${apiUrl}/${resource}/${params.id}`, {
      method: 'DELETE',
    })
      .then(({ json }) => ({ data: json }))
      .catch(({ message }) => ({
        error: message,
      }));
}

const dataService = new DataService();

export default dataService;
